export default __webpack_public_path__ + "static/media/york-logo-reversed.8577f0d2.svg";